import moment from 'moment';

export default {
  data() {
    return {
      now: Date.now(),
      nowInterval: null,
    };
  },
  mounted() {
    this.nowInterval = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.nowInterval);
  },
  methods: {
    isExpired(expiry) {
      return !!expiry && moment.utc(expiry).local() < new Date(this.now);
    },
    formatCountdown(expiry) {
      if (!expiry || this.isExpired(expiry)) return null;
      const minutes = Math.max(0, moment.utc(expiry).local().diff(moment(this.now), 'minutes'));
      return moment.utc(minutes * 60 * 1000).format('HH[h]mm');
    },
  },
};
